import { MonitorType } from "@/services/backend/qpm/types/enums";

export class MonitorTypeUtil {
  private static descriptions: { [key in MonitorType]: string } = {
    [MonitorType.Checkpoint]: "Prüfpunkt",
    [MonitorType.FlyExterminator]: "Fluginsektenvernichter",
    [MonitorType.IoT]: "IoT-Monitor",
  };

  private static abbreviations: { [key in MonitorType]: string } = {
    [MonitorType.Checkpoint]: "PP",
    [MonitorType.FlyExterminator]: "FIV",
    [MonitorType.IoT]: "IoT",
  };

  static toString(type: MonitorType): string {
    return this.abbreviations[type];
  }

  static toLongString(type: MonitorType): string {
    return this.descriptions[type] || "Unknown";
  }

  static supportsRentingDefaults(type: MonitorType): boolean {
    return type === MonitorType.IoT;
  }

  static supportsConsumables(type: MonitorType): boolean {
    return type === MonitorType.FlyExterminator;
  }
}
